import { useCallback, useEffect, useState } from 'react';

// Consent belongs only to the currently displayed reservation and terms, not to
// a browser session. Reopening a payment flow always requires a fresh choice.
export default function useCancellationAgreement(scope, active = true) {
  const [acceptedScope, setAcceptedScope] = useState(null);

  useEffect(() => {
    setAcceptedScope(null);
  }, [scope, active]);

  const setAgreed = useCallback((value) => {
    setAcceptedScope(active && value === true ? scope : null);
  }, [scope, active]);

  return { agreed: active && acceptedScope !== null && acceptedScope === scope, setAgreed };
}
